<template>
  
  <div id="app_content" class="public">

    <div class="content" :class="{v_loading: !message}">

      <div class="back">
        <a :href="return_link">{{trans.get('auth.return_link')}}</a>
      </div>

      <h3>{{message}}</h3>

    </div>

  </div>

</template>

<script>
export default{

  data: function(){

    return {
      message: null,
      loading: true,
      return_link: window.location.origin,
      key: null
    }

  },

  methods: {

    verifyUser: function(){

      var vue = this;

      axios({
        method: "post",
        url: window.location.origin + '/data/verify-user',
        data: {
          key: vue.key
        }
      })
      .then(res => {
        vue.message = res.data.message;
        console.log(res)
      })
      .catch(err => {
        console.log('errore:', err);
        vue.message = err.response.data.message;
      })

    }

  },

  beforeMount: function(){

    this.key = new URLSearchParams(window.location.search).get('key');

  },

  mounted: function(){

    this.verifyUser();

  }

}
</script>

<style scoped>
#app_content{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--black);
}
.content{
  width: 800px;
  max-width: 95%;
  height: auto;
  padding: 4em;
  border: 1px solid white;
  background-color: white;
}
.back{
  text-align: right;
}
.back a{
  color: var(--blue);
  text-decoration: underline;
}
</style>
